angular.module('impactx.approval').controller('RedirectUserCtrl', RedirectUserCtrl);

RedirectUserCtrl.$inject = ['$scope', '$mdDialog', 'dataGen'];

function RedirectUserCtrl($scope, $mdDialog, dataGen) {
    var ctrl = this;

    dataGen.postAsForm($scope, ctrl.selectionData, "/approval/redirect/view").then(function() {
    });

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
    $scope.answer = function() {
        if ($scope.data.user.selected) {
            $mdDialog.hide($scope.data.user.selected);
        }
    };
}